import sample from 'lodash/sample';
import { useTranslation } from 'next-i18next';
import { FC, useEffect, useState } from 'react';

import { assets } from 'external-modules/ui';

export enum Feedbacks {
  Automatic = 'automatic',
  Check = 'check',
  None = 'none'
}

export type RandomizedFeedback = {
  RandomizedIcon: FC;
  randomizedText: string;
  withAnimation: boolean;
};

export enum FeedbackMessages {
  NoAnswer = 'noAnswer',
  OnlyWrongAnswers = 'onlyWrongAnswers',
  NotAllCorrectAndNoWrongAnswers = 'notAllCorrectAndNoWrongAnswers',
  SomeCorrectAndSomeWrongAnswers = 'someCorrectAndSomeWrongAnswers',
  OnlyAllCorrectAnswers = 'onlyAllCorrectAnswers',
  ShowAnswer = 'showAnswer'
}

export type FeedbackMessageType = `${FeedbackMessages}`;

type FeedbackIconMap = Record<FeedbackMessageType, FC>;

const feedbackIconMap: FeedbackIconMap = {
  onlyAllCorrectAnswers: assets.feedbackIcons.AnswerSuccess,
  onlyWrongAnswers: assets.feedbackIcons.AnswerFailure,
  noAnswer: assets.feedbackIcons.AnswerFailure,
  notAllCorrectAndNoWrongAnswers: assets.feedbackIcons.AnswerPartialSuccess,
  someCorrectAndSomeWrongAnswers: assets.feedbackIcons.AnswerPartialSuccess,
  showAnswer: assets.feedbackIcons.NoAnswer
};

export const useRandomizedFeedback = (feedbackMessageType: FeedbackMessageType | null): RandomizedFeedback | null => {
  const { t } = useTranslation('widgets');

  const [randomizedFeedback, setRandomizedFeedback] = useState<RandomizedFeedback | null>(null);
  useEffect(() => {
    if (feedbackMessageType) {
      const RandomizedIcon = feedbackIconMap[feedbackMessageType];
      const feedbackList = t(`selectionQuestionWidget.feedbackMessages.${feedbackMessageType}`);
      const randomizedText = sample(feedbackList) || '';
      const withAnimation = feedbackMessageType === FeedbackMessages.OnlyAllCorrectAnswers;
      setRandomizedFeedback({ RandomizedIcon, randomizedText, withAnimation });
    }
  }, [feedbackMessageType, t]);

  return randomizedFeedback;
};
